import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=c5761bf2&"
import script from "./NotificationForm.vue?vue&type=script&lang=js&"
export * from "./NotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationForm.vue?vue&type=style&index=0&id=c5761bf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports